import { Component, effect, inject } from "@angular/core";
import { CommonModule } from "@angular/common";

import { Observable } from "rxjs";

import { VERSION } from "@core/version";
import { StatusBadgeComponent } from "@shared/components";
import {
  MySequencesComponent,
  HomeService,
  SearchOverlayComponent,
  AboutComponent,
  AdminComponent,
} from "@features/home";
import { ParsedSequence, StatusBadgeConfig } from "@shared/models";
import { GlobalService } from "@shared/services";
import { LocalStorage } from "@shared/enums";

@Component({
  selector: "app-home",
  standalone: true,
  imports: [
    MySequencesComponent,
    SearchOverlayComponent,
    CommonModule,
    StatusBadgeComponent,
    AboutComponent,
    AdminComponent,
  ],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
})
export class HomeComponent {
  globalService = inject(GlobalService);
  homeService = inject(HomeService);

  version = VERSION;
  isLoading: boolean = false;
  searchVisible: boolean = false;
  isEmulating: boolean = false;
  emulateStatus: StatusBadgeConfig = {
    class: "status removed",
    icon: "pi pi-user",
    text: "",
  };
  noSequenceStatus: StatusBadgeConfig = {
    class: "status scheduled",
    icon: "pi pi-calendar",
    text: "No Upcoming Sequences",
  };
  currentSequence$: Observable<ParsedSequence> =
    this.homeService.getCurrentSequence(false, this.getUser());

  constructor() {
    effect(() => {
      if (this.globalService.emulatedUser()) {
        this.currentSequence$ = this.homeService.getCurrentSequence(
          false,
          this.getUser(),
        );
      } else {
        this.currentSequence$ = this.homeService.getCurrentSequence(
          false,
          this.getUser(),
        );
      }
    });
  }

  private getUser(): string {
    const emulatedUser = localStorage.getItem(LocalStorage.EmulatedUser);
    if (emulatedUser) {
      return emulatedUser;
    }
    return "";
  }

  getEmulatedStatus(): StatusBadgeConfig {
    this.emulateStatus.text = this.globalService.emulatedUser() || "";
    return this.emulateStatus;
  }
}
